// @flow
import { connect } from 'react-redux'
import type { Store } from '../../redux/ducks'
import LeadformSelect, { type Props } from './LeadformSelect'
import { open as openForm } from '../../redux/ducks/leadformEdit/reducers'
import { patch as patchAudience } from '../AudienceEditContainer'
import type { Configs, Leadform } from '../types'
import _ from 'lodash'
import type { SocialPublicProps } from '../../redux/ducks/audienceEdit/reducers'

type OwnProps = {|
  errors: Array<string>,
  adAccountId: number,
  configs: Configs,
  socialPublicProps: SocialPublicProps,
  isDisabled: boolean
|}

function mapStateToProps(state: Store): $Shape<Props> {
  const leadforms = state.leadforms.items
  const options = _.map(leadforms, (lf: Leadform) => ({ id: lf.id, name: lf.name }))

  return { options, leadformId: state.audienceEdit.leadformId }
}

function mapDispatchToProps(dispatch: Function) {
  return {
    onCreate: () => {
      dispatch(openForm(null))
    },
    onLeadformIdChange: (id: number) => {
      patchAudience(dispatch, { leadformId: id, leadformIdErrors: [] })
    }
  }
}

const LeadformSelectContainer = connect<Props, OwnProps, _, _, _, _>(
  mapStateToProps,
  mapDispatchToProps
)(LeadformSelect)

export default LeadformSelectContainer
